export default __webpack_public_path__ + "assets/77e239f2b474b58ef788e804916e5f86.png";